<template>
  <div>
    <!-- <p v-for="(guias, index) in listGuias" :key=index>{{guias}}</p> -->
    <v-card>
      <v-toolbar color="" dark flat>
        Listado de Documentos: {{po_box}}
        <template v-slot:extension>
          <v-tabs v-model="tab" dark align-with-title>
            <v-tabs-slider color=""></v-tabs-slider>
            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
          <v-spacer></v-spacer>
          <v-text-field
            label="Po.Box"
            prepend-inner-icon="mdi-magnify"
            clearable
            v-model="po_box"
            @change="searchData"
            @click:clear="clearData"
          >
          </v-text-field>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item">
          <v-card flat>
            <v-card-text>
              <v-list subheader two-line>
                <v-subheader inset>Files ({{ item }})</v-subheader>
                <v-list-item
                  v-for="(file, index) in dataList(item)"
                  :key="index"
                >
                  <v-list-item-avatar>
                    <v-icon
                      :class="icons.color"
                      dark
                      v-text="icons.icon"
                    ></v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="file.date"></v-list-item-title>

                    <v-list-item-subtitle
                      v-text="file.id"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      class="mx-2"
                      fab
                      light
                      small
                      color="primary"
                      :href="file.link"
                      target="_blank"
                    >
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},

  data: () => ({
    po_box: "",
    tab: null,
    items: [
      "Guías",
      "Dest. Simplif.",
      "Caratulas",
      "Facturas",
      "Recibos",
      "Guías Madre",
      "Notas de Credito"
    ],
    icons: {
      color: "blue",
      icon: "mdi-clipboard-text",
    },
  }),

  computed: {
    ...mapGetters("documents", [
      "listGuias",
      "listFacturas",
      "listRecibos",
      "listParticulares",
      "listCaratulas",
      "listOtros",
      "listGuiasMadre",
      "listNotasCredito"
    ]),
  },

  mounted() {
    this.initialize();
  },

  methods: {
    ...mapActions("documents", ["listDocuments", "resetDocuments"]),

    initialize() {
      return this.listDocuments();
    },

    dataList(item) {
      switch (item) {
        case "Guías Madre":
          return this.listGuiasMadre;
        case "Guías":
          return this.listGuias;
        case "Dest. Simplif.":
            return this.listOtros;
        case "Facturas":
          return this.listFacturas;
        case "Recibos":
          return this.listRecibos;
        case "Caratulas":
          return this.listCaratulas;
        case "Notas de Credito":
          return this.listNotasCredito;
      }
    },
    searchData() {
      return this.po_box ? this.listDocuments(this.po_box) : this.resetDocuments()
    },
    clearData() {
      this.resetDocuments();
    }
  },
};
</script>